var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1621 7.6772H16.2803C14.4739 7.68038 13.0105 9.10721 13.0072 10.8685C13.0048 12.6338 14.4698 14.067 16.2803 14.0694H20.1654V14.3498C20.1654 17.4291 18.2986 19.25 15.1396 19.25H6.85862C3.69877 19.25 1.83203 17.4291 1.83203 14.3498V7.64304C1.83203 4.56374 3.69877 2.75 6.85862 2.75H15.1363C18.2954 2.75 20.1621 4.56374 20.1621 7.64304V7.6772ZM6.17662 7.67005H11.3466H11.3499H11.3564C11.7434 7.66846 12.0563 7.36101 12.0547 6.98285C12.0531 6.60548 11.7369 6.30041 11.3499 6.302H6.17662C5.79203 6.30359 5.47996 6.60786 5.47833 6.98364C5.4767 7.36101 5.78959 7.66846 6.17662 7.67005Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6984 11.2712C14.89 12.1431 15.6545 12.7565 16.5273 12.7406H19.5064C19.8695 12.7406 20.1641 12.4398 20.1641 12.0681V9.7475C20.1633 9.37656 19.8695 9.07502 19.5064 9.07422H16.4571C15.4644 9.07741 14.6625 9.90146 14.6641 10.917C14.6641 11.0358 14.6758 11.1547 14.6984 11.2712Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4987,
    cy: 10.9089,
    r: 0.916667,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.bfed333edb9050b86df5fe68c0aa4011.svg";
export { ForwardRef as ReactComponent };